module.exports = __webpack_public_path__ + "img/typesOfGalaxies.8297f88b.jpg";